import builder from '../builder';
import CalendarCheck from '../../streamline-icons/light/calendar-check.svg';

export default builder('IconCalendarCheckLight', CalendarCheck);
